module.exports = __webpack_public_path__ + "static/media/8.a6b0666e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/beards/8.png
// module id = 1192
// module chunks = 0